<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        sm="6">
        <v-text-field
          v-model="searchCriteria.bookingNumber"
          prepend-icon="mdi-book-open-outline"
          label="Booking number"
          dense
        ></v-text-field>

        <v-text-field
          v-model="searchCriteria.firstName"
          prepend-icon="mdi-alpha-f-box-outline"
          label="First name"
          dense
        ></v-text-field>
        <v-text-field
          v-model="searchCriteria.surname"
          prepend-icon="mdi-alpha-l-box-outline"
          label="Last Name"
          dense
        ></v-text-field>
        <v-text-field
            v-model="searchCriteria.mobileNumber"
            label="Mobile number"
            prepend-icon="mdi-cellphone"
            placeholder="04XX-XXX-XXX or +614XX-XXX-XXX"
            dense>
        </v-text-field>

        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="fmtPickUpBookingDate"
              label="Booking date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              dense
              clearable
              @click:clear="searchCriteria.bookingDate = null"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="searchCriteria.bookingDate"
            @input="menu2=false">
          </v-date-picker>
        </v-menu>
        <v-btn
          class="ma-2 primary"
          @click="searchBookings">
          Search
          <v-icon class="ml-2">mdi-account-search-outline</v-icon>
        </v-btn>
        <v-btn
          class="ma-2 secondary"
          @click="clearSearch">
          Clear
          <v-icon class="ml-2">mdi-eraser</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-data-table
      :headers="headers"
      :items="BOOKING_SEARCH_RESULTS">
        <template v-slot:item.fare="{ item }">
           <span>{{item.fare | toCurrency}}</span>
        </template>
        <template v-slot:item.departDate="{ item }">
          <span>{{$moment(item.departDate).format(SHORT_DATE_FORMAT)}}</span>
          <v-icon
            small
            class="ml-2 red--text"
            title="Cancel Inbound"
            v-if="showCancelInbound(item)"
            @click="openDialog(item,
              item.departDate,
              1,
              false,
              'Cancel the Inbound')">mdi-cancel
          </v-icon>
          <v-icon
            small
            class="ml-2 green--text"
            title="Restore Inbound"
            v-if="showRestoreInbound(item)"
            @click="openDialog(item,
              item.departDate,
              1,
              true,
            'Restore the Inbound')">mdi-undo-variant
          </v-icon>
        </template>
        <template v-slot:item.arriveDate="{ item }">
         <span>{{$moment(item.arriveDate).format(SHORT_DATE_FORMAT)}}</span>
         <v-icon
            small
            class="ml-2 red--text"
            title="Cancel Outbound"
            v-if="showCancelOutbound(item)"
            @click="openDialog(item,
              item.arriveDate,
              2,
              false,
              'Cancel the Outbound')">mdi-cancel
          </v-icon>
          <v-icon
            small
            class="ml-2 green--text"
            title="Restore Outbound"
            v-if="showRestoreOutbound(item)"
            @click="openDialog(item,
              item.arriveDate,
              2,
              true,
              'Restore the Outbound')">mdi-undo-variant
          </v-icon>
        </template>
        <template v-slot:item.mobileNumber="{ item }">
          <v-btn v-if="item.mobileNumber"
            tile
            outlined
            color="primary"
            :href="`tel:${ item.mobileNumber }`">
            <v-icon left>mdi-cellphone</v-icon> {{ item.mobileNumber }}
          </v-btn>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            class="mr-2"
            title="Edit booking"
            @click="editBooking(item)">mdi-pencil
          </v-icon>
          <v-icon
            small
            class="mr-2"
            title="New booking"
            @click="newCustomerBooking(item)">mdi-plus-circle-outline
          </v-icon>
          <v-icon
            small
            class="mr-2"
            title="Copy Invoice"
            @click="copyInvoice(item)">mdi-database-export
          </v-icon>
        </template>
      </v-data-table>
    </v-row>
    <v-dialog v-model="dialogBookingAction" max-width="500px">
      <v-card>
        <v-card-title>
          Are you sure you want to {{ actionText }} booking?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="performAction">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mask } from 'vue-the-mask';
import storeConstants from '@/store/storeConstants';

export default {
  name: 'SearchBookings',
  directives: {
    mask,
  },
  data: () => ({
    dialogBookingAction: false,
    action: null,
    direction: null,
    actionText: null,
    actionDate: null,
    selectedAction: null,
    selectedBooking: null,
    menu2: false,
    mobileMask: '####-###-###',
    searchCriteria: {
      bookingNumber: null,
      firstName: null,
      surname: null,
      mobileNumber: null,
      landlineNumber: null,
      bookingDate: null,
    },
    headers: [
      { text: 'Booking #', value: 'bookingId' },
      {
        text: 'First name',
        align: 'start',
        filterable: false,
        value: 'firstName',
      },
      { text: 'LastName', value: 'lastName' },
      { text: 'Mobile #', value: 'mobileNumber' },
      { text: 'Payment Method', value: 'paymentMethod' },
      { text: 'Amount ($)', value: 'fare' },
      { text: 'Direction', value: 'directionName' },
      { text: 'Departure Date', value: 'departDate' },
      { text: 'Arrival Date', value: 'arriveDate' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
  }),
  mounted() {
    // replace the default 'Invalid Date' moment message.
    this.RESET_BOOKING_SEARCH();
    this.$moment.updateLocale(this.$moment.locale(), { invalidDate: '-' });
  },
  methods: {
    ...mapActions([storeConstants.SEARCH_BOOKINGS,
      storeConstants.GET_BOOKING_INVOICE,
      storeConstants.RESET_BOOKING_SEARCH,
      storeConstants.SAVE_BOOKING_ACTION]),
    editBooking(booking) {
      this.$router.push({ name: 'editBooking', params: { id: booking.bookingId } });
    },
    newCustomerBooking(booking) {
      this.$router.push({ name: 'newBooking', params: { customerId: booking.customerId } });
    },
    closeDialog() {
      this.dialogBookingAction = false;
      this.actionText = null;
      this.actionDate = null;
      this.selectedAction = null;
      this.selectedBooking = null;
    },
    openDialog(booking, bookingDate, direction, action, actionText) {
      this.dialogBookingAction = true;
      this.action = action;
      this.actionDate = bookingDate;
      this.direction = direction;
      this.actionText = actionText;
      this.selectedBooking = booking;
    },
    showCancelInbound(item) {
      return !!item.departDate && item.isActiveIn
        && (item.directionId === 3 || item.directionId === 1);
    },
    copyInvoice(item) {
      this.GET_BOOKING_INVOICE(item.bookingId).then(() => {
        navigator.clipboard.writeText(this.BOOKING_INVOICE);
      });
    },
    // in = depart = to airport     --> 1
    // out = arrival = from airport --> 2

    // 1 To the Airport
    // 2 From the Airport
    // 3 Return Trip
    showRestoreInbound(item) {
      return !!item.departDate && !item.isActiveIn
        && (item.directionId === 3 || item.directionId === 1);
    },
    showCancelOutbound(item) {
      return !!item.arriveDate && item.isActiveOut
        && (item.directionId === 3 || item.directionId === 2);
    },
    showRestoreOutbound(item) {
      return !!item.arriveDate && !item.isActiveOut
        && (item.directionId === 3 || item.directionId === 2);
    },
    performAction() {
      const data = {
        action: this.action,
        direction: this.direction,
        bookingId: this.selectedBooking.bookingId,
        bookingDate: this.actionDate,
      };

      this.SAVE_BOOKING_ACTION(data).then(() => {
        this.searchBookings();
        this.closeDialog();
      });
    },
    searchBookings() {
      this.$store.commit('SET_LOADING_TEXT', 'Searching for bookings...');
      this.$store.commit('SET_LOADING', true);

      this.SEARCH_BOOKINGS(this.searchCriteria)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
        },
        (error) => {
          this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
          this.$store.commit('SET_LOADING', false);
        })
        .catch(() => {
          this.$store.commit('SET_LOADING', false);
        });
    },
    clearSearch() {
      this.$store.commit(storeConstants.SET_BOOKINGS, []);
      this.searchCriteria = {};
    },
  },
  computed: {
    ...mapGetters([
      storeConstants.BOOKING_SEARCH_RESULTS,
      storeConstants.BOOKING_INVOICE,
      storeConstants.SHORT_DATE_FORMAT,
      storeConstants.DISPLAY_DATE_FORMAT]),
    fmtPickUpBookingDate() {
      if (!this.searchCriteria.bookingDate) {
        return null;
      }
      return this.$moment(this.searchCriteria.bookingDate).format(this.DISPLAY_DATE_FORMAT);
    },
  },
};
</script>
<style scoped>
.v-dialog > .v-card > .v-card__title {
    font-size: 1rem;
}
</style>
